.channelListContainer {
  overflow-y: auto;
  height: calc(100vh - 120px);
  margin-top: 25px;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.container::-webkit-scrollbar {
  display: none;
}

.channelsLoadingContainer {
  display: block;
  text-align: center;
  color: #0a64b2;
}

.loadMore {
  margin: 0;
  padding: 0;
  font-size: 12px;
  color: #22a7e7;
  font-weight: 600;
  width: 100%;
}

@media only screen and (max-device-width: 700px) {
  .channelListContainer {
    height: unset;
    width: 100%;
  }
}
